import Vue from 'vue'
export default {
  methods: {
    markDataNonReactive (data) {
      if (data) {
        this.nonReactive(data.xValue)
        data.series.forEach(set => this.nonReactive(set.yValue))
      }
      return data
    },
    nonReactive (value) {
      const Observer = (new Vue()).$data.__ob__.constructor
      value.__ob__ = new Observer({})
      return value
    },
  },
}
